import FragmentBadges from "./FragmentBadges";

const FragmentListItem = ({
  fragment,
  isSelected,
  isInUse,
  needsUpdate,
  currentPromptFragments,
  onClick,
  onContextMenu,
}) => {
  const currentVersion = isInUse ? fragment.latest : null;

  return (
    <div
      className={`p-2 border-b border-gray-700 cursor-pointer hover:bg-gray-700 ${
        isSelected ? "bg-gray-700" : ""
      } ${!isInUse ? "opacity-70" : ""}`}
      onClick={() => onClick(fragment)}
      onContextMenu={(e) => onContextMenu(e, fragment)}
    >
      <div className="flex justify-between items-center">
        <div>
          <div
            className={`font-medium ${
              isInUse ? "text-white" : "text-gray-400"
            }`}
          >
            {fragment.name}{" "}
            <span className="font-mono text-gray-500">
              ({fragment.block_name})
            </span>
            {needsUpdate && (
              <span className="ml-2 text-yellow-400 text-xs">
                (update available)
              </span>
            )}
          </div>
          {fragment.description && (
            <div
              className={`text-sm ${
                isInUse ? "text-gray-400" : "text-gray-500"
              }`}
            >
              {fragment.description}
            </div>
          )}
        </div>
        {currentVersion && (
          <div className="flex items-center">
            <FragmentBadges
              fragment={fragment}
              currentPromptFragments={currentPromptFragments}
              needsUpdate={needsUpdate}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FragmentListItem;
